export const URL = "https://validations.indivillage.com/api/";


//export const URL = "http://southvalidationapp-env.eba-jmaq2kez.ap-south-1.elasticbeanstalk.com/api/";

//export const URL = "http://southvalidationapp-dev.ap-south-1.elasticbeanstalk.com/api/";

//export const URL = "http://localhost:8080/api/";